<template>
  <div class="container">
    <div v-if="!orderbool">
      <h3 class="green subtitle">{{ $translate('subtitle_form_model_fodera') }}</h3>
      <hr />
    </div>

    <div class="columns">
      <div class="column is-8">
        <b-field v-if="!orderbool" :label="$translate('elastic_model') | capitalize">
          <b-switch v-model="mod.isElastic"></b-switch>
        </b-field>
        <div class="columns" v-for="(fodmat, index) in mod.fodmat" :key="index">
          <div class="column">
            <b-field
              :type="{ 'is-danger': errors.has(`fodmat-${index}-material`) }"
              :label="$translate('fodmat') | capitalize"
              :message="errors.first(`fodmat-${index}-material`)"
            >
              <b-select
                v-model="fodmat.material"
                v-validate="{ required: (mod.custom && !mod.from_duna_catalog) || orderInfoMandatory }"
                :disabled="disabledbool"
                :name="`fodmat-${index}-material`"
                :placeholder="$translate('placeholder_select')"
                @input="resetTags(index)"
              >
                <option
                  v-for="optio in availablefode"
                  :key="optio.id"
                  :value="optio.id"
                  :label="$translateMaterial(optio)"
                >
                  {{ $translateMaterial(optio) }}
                </option>
              </b-select>
            </b-field>

            <b-field
              v-show="fodmat.material != null"
              :type="{ 'is-danger': errors.has(`fodmat-${index}-variant`) }"
              :label="$translate('fodantvar') | capitalize"
              :message="errors.first(`fodmat-${index}-variant`)"
            >
              <b-select
                v-model="fodmat.variant"
                v-validate="{ required: (mod.custom && !mod.from_duna_catalog) || orderInfoMandatory }"
                :disabled="disabledbool"
                :name="`fodmat-${index}-variant`"
                :placeholder="$translate('placeholder_select')"
                @input="updateModel(index)"
              >
                <template v-for="optio in availablefode">
                  <template v-if="optio.id === fodmat.material">
                    <option v-for="variant in optio.variants" :key="variant.id" :value="variant">
                      {{ $translateMaterialVariant(variant) }}
                    </option>
                  </template>
                </template>
              </b-select>
            </b-field>
            <button type="button" class="button is-danger" @click="deleteFodMat(index)">
              {{ $translate('delete_fodera') | capitalize }}
            </button>
            <hr />
          </div>
          <div class="column">
            <img
              :src="fodmat.variant ? fodmat.variant.image : 'https://place-hold.it/150x150'"
              style="max-width: 150px; max-height: 150px;"
            />
          </div>
        </div>
      </div>
      <div class="column">
        <b-field :label="$translate('addingcharfod') | capitalize">
          <b-select
            v-model="mod.addingcharfod"
            multiple
            native-size="5"
            :disabled="orderbool"
            name="addingcharfod"
            :placeholder="$translate('placeholder_select')"
          >
            <option v-for="option in optionsaddingcharfod" :key="option" :value="option">
              {{ option }}
            </option>
          </b-select>
        </b-field>
        <p class="content">{{ $translate('multiple_select_info') | capitalize }}</p>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <button type="button" class="button is-primary" @click="addFodmat">
          {{ $translate('add_fodera') | capitalize }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Fodera',
  props: ['orderbool', 'mod', 'availablefode', 'disabledbool', 'orderInfoMandatory'],
  data() {
    return {
      optionsaddingcharfod: [],
      isElastic: false,
    }
  },
  inject: ['$validator'],
  mounted() {
    if (!Array.isArray(this.mod.fodmat)) {
      this.$set(this.mod, 'fodmat', [{ material: null, variant: null }])
    }
  },
  methods: {
    addFodmat() {
      this.mod.fodmat.push({ material: null, variant: null })
    },
    deleteFodMat(index) {
      this.mod.fodmat = this.mod.fodmat.filter((size, i) => i !== index)
    },
    resetTags(index) {
      this.mod.fodmat[index].variant = null
      this.updateAddingCharFod()
    },
    updateModel(index) {
      const selectedMaterial = this.availablefode.find(optio => optio.id === this.mod.fodmat[index].material)
      if (selectedMaterial) {
        this.mod.fodmat[index].commercial_name = selectedMaterial.commercial_name
      }
    },
    updateAddingCharFod() {
      this.optionsaddingcharfod = []
      this.mod.fodmat.forEach(fodmat => {
        const material = this.availablefode.find(optio => optio.id === fodmat.material)
        if (material) {
          material.optional_tag.forEach(tag => {
            if (!this.optionsaddingcharfod.includes(tag.key)) {
              this.optionsaddingcharfod.push(tag.key)
            }
          })
        }
      })
    },
  },
}
</script>
